import level1 from './Level1.json'

let levels = {
    'level1': level1
}

let spawnDefs = {
    'level1': [
        {
            music: 'slime forest',
            afterElapsed: 0, // Number of miliseconds since level start after which this enemy can spawn.
            // Formula for this is Minutes * Seconds * Miliseconds
            beforeElapsed: 0.25 * 60 * 1000, // Number of miliseconds since level start after which this enemy will NOT spawn.
            enemies: ['bat'],
            maxEnemyCount: 3, // Max number of enemies on screen (will only spawn if count is < this number).
            spawnDelay: 500, // Min number of miliseconds between group spawns.
        },
        { 
            afterElapsed: 0.25 * 60 * 1000, // Number of miliseconds since level start after which this enemy can spawn.
            beforeElapsed: 1 * 60 * 1000, // Number of miliseconds since level start after which this enemy will NOT spawn.
            enemies: ['slime', 'bat'],
            maxEnemyCount: 16, // Max number of enemies on screen (will only spawn if count is < this number).
            spawnDelay: 500, // Min number of miliseconds between group spawns.
        },
        { 
            afterElapsed: 0.75 * 60 * 1000, // Number of miliseconds since level start after which this enemy can spawn.
            beforeElapsed: 1 * 60 * 1000, // Number of miliseconds since level start after which this enemy will NOT spawn.
            enemies: ['slime', 'bat'],
            maxEnemyCount: 25, // Max number of enemies on screen (will only spawn if count is < this number).
            spawnDelay: 1000, // Min number of miliseconds between group spawns.
        },
        { 
            afterElapsed: 1 * 60 * 1000, // Number of miliseconds since level start after which this enemy can spawn.
            beforeElapsed: 2 * 60 * 1000, // Number of miliseconds since level start after which this enemy will NOT spawn.
            enemies: ['bigslime', 'slime', 'bat'],
            maxEnemyCount: 35, // Max number of enemies on screen (will only spawn if count is < this number).
            spawnDelay: 1500, // Min number of miliseconds between group spawns.
        }
        ,
        { 
            afterElapsed: 2 * 60 * 1000, // Number of miliseconds since level start after which this enemy can spawn.
            beforeElapsed: 3 * 60 * 1000, // Number of miliseconds since level start after which this enemy will NOT spawn.
            enemies: ['bigslime', 'slime', 'bat', 'toad'],
            maxEnemyCount: 20, // Max number of enemies on screen (will only spawn if count is < this number).
            spawnDelay: 2000, // Min number of miliseconds between group spawns.
        }
        ,
        { 
            afterElapsed: 3 * 60 * 1000, // Number of miliseconds since level start after which this enemy can spawn.
            beforeElapsed: 4 * 60 * 1000, // Number of miliseconds since level start after which this enemy will NOT spawn.
            enemies: ['bigslime', 'slime', 'bat', 'slime', 'bat', 'slime', 'toad'],
            maxEnemyCount: 60, // Max number of enemies on screen (will only spawn if count is < this number).
            spawnDelay: 1000, // Min number of miliseconds between group spawns.
        }
        ,
        {
            music: 'dark cavern',
            afterElapsed: 4 * 60 * 1000, // Number of miliseconds since level start after which this enemy can spawn.
            beforeElapsed: 999 * 60 * 1000, // Number of miliseconds since level start after which this enemy will NOT spawn.
            enemies: ['kingslime'],
            maxEnemyCount: 1, // Max number of enemies on screen (will only spawn if count is < this number).
            spawnDelay: 1000, // Min number of miliseconds between group spawns.
        }

    ]
}

let hints = {
    'level1': 'Hint 1.'
}

/**
 * Return the level name (null if it doesn't exist)
 * @param {string} level 
 * @returns {object}
 */
function GetLevel(level) {
    try {
        return JSON.parse(JSON.stringify(levels[level]))
    } catch {}
    return null
}

function GetHint(level) {
    try {
        return hints[level]
    } catch {}
    return ''
}

/**
 * Any spawn definitions active for given elapsed number.
 * @param {string} level 
 * @param {number} elapsed 
 * @returns 
 */
function GetSpawns(level, elapsed) {
    try {
        let spawns = spawnDefs[level]
        return spawns.filter(f => f.afterElapsed <= elapsed && f.beforeElapsed >= elapsed)
    } catch {}
    return []
}

export { GetLevel, GetHint, GetSpawns }